/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Directive, EventEmitter, HostListener, Input, Output} from "@angular/core";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";

import {AigiaInfoDialogComponent} from "../../base/components/aigia-info-dialog/aigia-info-dialog.component";
import {StuffGuestRegistDialogComponent} from "./stuff-guest-regist-dialog.component";
import {AuthLevel} from "../../../../../types/aig/universe";

/**
 * todo
 */
@Directive({
	selector: "[aigia-guest-regist-button]",
})

export class StuffGuestRegistDialogDirective {

	public agree: boolean = false;

	private resultDialogContent: any = {title: "メール送信完了", message: "新規登録のメールをお送りしました。メールをご確認ください。"};

	@Output() public complete = new EventEmitter<any>();
	@Input() public username: string;
	@Input() public params: string;

	/**
	 *
	 * @param matDialog
	 */
	constructor(
		private matDialog: MatDialog,
	) {
	}

	/**
	 * todo
	 */
	public changeAgree(event: any): void {
		this.agree = event.checked;
	}

	/**
	 * todo
	 */
	private Complete(type: string, value: any): void {
		this.complete.emit({type, value});
	}

	/**
	 *
	 * @param target
	 */
	@HostListener("click", ["$event.target"])
	public onClick(): void {

		const dialog: MatDialogRef<any> = this.matDialog.open(StuffGuestRegistDialogComponent, {
			panelClass: "dark-card",
			height: "fit-content",
			width: "60%",
			data: {
				content: {
					title: "管理アカウントを作成する " + this.username,
					description: "",
					username: "",
					nickname: "",
					password: "",
					confirm_password: "",
					type: "trainer",
					auth: AuthLevel.trainer,
					params: this.params
				},
			},
			disableClose: true,
		});

		dialog.beforeClosed().subscribe((result: any): void => {
			if (result) {
				const info_dialog: MatDialogRef<any> = this.matDialog.open(AigiaInfoDialogComponent, {
					width: "50%",
					minWidth: "320px",
					height: "fit-content",
					data: {content: this.resultDialogContent},
					disableClose: true,
				});

				info_dialog.afterClosed().subscribe((result: any): void => {

				});
			}
		});

		dialog.afterClosed().subscribe((result: any): void => {
			if (result) {
				this.Complete("", result);
			}
		});
	}

}
